import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card card-body mb-0" }
const _hoisted_5 = { class: "row mt-2" }
const _hoisted_6 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_7 = { class: "col p-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_14 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_15 = { class: "col p-0" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_18 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_19 = { class: "col p-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "form-group mb-2 col" }
const _hoisted_22 = { class: "col-auto p-0 text-end" }
const _hoisted_23 = { class: "col-sm-12" }
const _hoisted_24 = { class: "card card-body" }
const _hoisted_25 = { class: "overflow-auto" }
const _hoisted_26 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_27 = { class: "text-capitalize-first" }
const _hoisted_28 = { class: "text-capitalize-first" }
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "text-capitalize-first" }
const _hoisted_31 = { class: "text-capitalize-first" }
const _hoisted_32 = { class: "text-capitalize-first" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_OperationDetails = _resolveComponent("OperationDetails")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["row", _ctx.mainClass ?? 'm-4 mt-0'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.invoice_id'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.dealId) = $event))
                        }, null, 8, _hoisted_9), [
                          [_vModelText, _ctx.requestDTO.dealId]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_13)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_17)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_Multiselect, {
                          id: "types",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.types,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                          options: Object.values(_ctx.OperationType),
                          "custom-label": (opt) => _ctx.helper.trans(`operation_type.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.type')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => _ctx.exportData(), ["prevent"])),
                        class: "btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first"
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-download me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.helper.trans('button.export')), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_b_modal, {
                    "dialog-class": "modal-lg",
                    title: _ctx.trans('labels.operation_details'),
                    modelValue: _ctx.detailsOperation !== null,
                    "body-class": "pt-0",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($event === false && (_ctx.detailsOperation = null)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OperationDetails, { operation: _ctx.detailsOperation }, null, 8, ["operation"])
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailsOperation = null)),
                        class: "btn btn-outline-dark btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.trans('button.close')), 1)
                    ]),
                    _: 1
                  }, 8, ["title", "modelValue"]),
                  _createElementVNode("table", _hoisted_26, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.trans("labels.date")), 1),
                        _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.trans("labels.currency")), 1),
                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.trans("labels.amount")), 1),
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.trans("labels.type")), 1),
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.trans("labels.balance_before")), 1),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.trans("labels.balance_after")), 1),
                        _cache[12] || (_cache[12] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations.items, (operation) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: operation.id,
                          class: _normalizeClass({'text-success': operation.transactionType === _ctx.TransactionType.CREDIT, 'text-danger': operation.transactionType !== _ctx.TransactionType.CREDIT})
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(operation.createdAt)), 1),
                          _createElementVNode("td", null, _toDisplayString(operation.currency), 1),
                          _createElementVNode("td", null, _toDisplayString(operation.transactionType === _ctx.TransactionType.CREDIT ? "+" : '-') + _toDisplayString(_ctx.numberFormatter.formatNumber(operation.sum)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.trans('operation_type.' + operation.operationType)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(operation.balanceBefore)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(operation.balanceAfter)), 1),
                          _createElementVNode("td", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.detailsOperation = operation),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, [
                              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-list" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.trans('button.details')), 1)
                            ], 8, _hoisted_34)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  (_ctx.operations.totalCount > _ctx.operations.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadOperations()))
                        ],
                        "total-rows": _ctx.operations.totalCount,
                        "per-page": _ctx.operations.limit,
                        limit: 20,
                        "prev-text": _ctx.trans('button.back'),
                        "next-text": _ctx.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 512))
}